"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _package = require("../../../package.json");

var _MetaView = _interopRequireDefault(require("./MetaView"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ENV = process.env.NODE_ENV;
var RELEASE_VERSION = process.env.branch;

var MetaContainer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MetaContainer, _Component);

  function MetaContainer(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      version: RELEASE_VERSION || _package.version || '??',
      date: _package.releaseDate || '??',
      env: ENV
    };
    return _this;
  }

  var _proto = MetaContainer.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, info) {
    console.log('error:', error, info); // Display fallback UI

    this.setState({
      hasError: error.message
    });
  };

  _proto.render = function render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_react["default"].createElement("div", null, ' ', "--- error in metaView --", this.state.error, ' ');
    }

    return /*#__PURE__*/_react["default"].createElement(_MetaView["default"], this.state);
  };

  return MetaContainer;
}(_react.Component);

exports["default"] = MetaContainer;